import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import InvestmentsMobile from './InvestmentsMobile';
import InvestmentsDesktop from './InvestmentsDesktop';

function Investments({ app, config }) {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    return isMobile ? <InvestmentsMobile app={app} config={config} />
        : <InvestmentsDesktop app={app} config={config} />;
}

Investments.defaultProps = {
    app: null,
    config: {}
};

Investments.propTypes = {
    app: PropTypes.object,
    config: PropTypes.object
};

export default Investments;
